import {reactive} from 'vue';
export const seoBrand=reactive({siteName:'همراه زر',tagline:'',logo:'',favicon:''});
